import Alpine from "alpinejs";

interface ChecklistSection {
	active: string;
	top: number;
	expanded: boolean;
	init: CallableFunction;
	setActive: CallableFunction;
	handleActiveUpdate: CallableFunction;
}

const checklistSection = (active: string): ChecklistSection => {
	return {
		active: active,
		top: 0,
		expanded: false,

		init(): void {
			Alpine.watch(
				() => this.active,
				(value: string) => this.handleActiveUpdate(value),
			);
			Alpine.nextTick(() => {
				window.dispatchEvent(new Event("resize"));
			});
		},

		handleActiveUpdate(value: string): void {
			this.expanded = false;
		},
	};
};

Alpine.data("checklistSection", checklistSection);
